module.exports = "/shifts/shift-swap/selectable-row-content-5a4496.html";